module.exports = __webpack_public_path__ + "media/images/ai-bot-6c0bc4ccd083548999f0dab6b3e73d63.svg";